import { useState } from "react";
import { User, AuthModal as AuthModalType } from "../types";

const AVATARS = ["🕵️", "🦉", "🔍", "🗝️", "🌑", "⚰️"];

interface Props {
  mode: AuthModalType;
  onClose: () => void;
  onAuth: (user: User) => void;
  switchMode: (mode: AuthModalType) => void;
}

export default function AuthModal({ mode, onClose, onAuth, switchMode }: Props) {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [selectedAvatar, setSelectedAvatar] = useState(AVATARS[0]);
  const [error, setError] = useState("");

  if (mode === "closed") return null;

  const isRegister = mode === "register";

  const handleSubmit = () => {
    if (isRegister) {
      if (!username.trim()) return setError("Choose a username.");
      if (!email.trim()) return setError("Email is required.");
      if (!password.trim()) return setError("Password is required.");
    } else {
      if (!email.trim()) return setError("Email is required.");
      if (!password.trim()) return setError("Password is required.");
    }
    setError("");
    onAuth({
      username: isRegister ? username.trim() : email.split("@")[0],
      email: email.trim(),
      avatar: selectedAvatar,
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>

        {/* Header */}
        <div className="modal-header">
          <div className="modal-logo">H<span>.</span>unch</div>
          <p className="modal-tagline">
            {isRegister
              ? "Join 14,203 detectives solving the case."
              : "Welcome back, detective."}
          </p>
        </div>

        {/* Avatar picker — register only */}
        {isRegister && (
          <div className="avatar-section">
            <div className="avatar-label">— Choose your identity</div>
            <div className="avatar-grid">
              {AVATARS.map((av) => (
                <button
                  key={av}
                  className={`avatar-option ${selectedAvatar === av ? "avatar-selected" : ""}`}
                  onClick={() => setSelectedAvatar(av)}
                >
                  {av}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Fields */}
        <div className="modal-fields">
          {isRegister && (
            <div className="field-wrap">
              <label className="field-label">Username</label>
              <input
                className="field-input"
                placeholder="cold_case_k"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoFocus
              />
            </div>
          )}
          <div className="field-wrap">
            <label className="field-label">Email</label>
            <input
              className="field-input"
              type="email"
              placeholder="you@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus={!isRegister}
            />
          </div>
          <div className="field-wrap">
            <label className="field-label">Password</label>
            <input
              className="field-input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && <p className="field-error">{error}</p>}

          <button className="modal-submit" onClick={handleSubmit}>
            {isRegister ? "Create account & continue" : "Sign in & continue"}
          </button>
        </div>

        {/* Switch mode */}
        <div className="modal-switch">
          {isRegister ? (
            <>
              Already have an account?{" "}
              <button className="modal-switch-btn" onClick={() => switchMode("login")}>
                Sign in
              </button>
            </>
          ) : (
            <>
              New here?{" "}
              <button className="modal-switch-btn" onClick={() => switchMode("register")}>
                Create account
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
